import { createBrowserRouter } from 'react-router-dom';
import { SiteLayout } from '@/components/layout/SiteLayout';
import { HomePage } from '@/pages/HomePage';
import { PostPage } from '@/pages/PostPage';
import { CategoriesPage } from '@/pages/CategoriesPage';
import { TagsPage } from '@/pages/TagsPage';
import { AboutPage } from '@/pages/AboutPage';
import { RssPage } from '@/pages/RssPage';
import { SitemapPage } from '@/pages/SitemapPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { ErrorPage } from '@/pages/ErrorPage';
import { AdminPage } from '@/pages/admin/AdminPage';
import { ContactPage } from '@/pages/ContactPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <SiteLayout />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'posts/:slug', element: <PostPage /> },
      { path: 'categories', element: <CategoriesPage /> },
      { path: 'categories/:category', element: <CategoriesPage /> },
      { path: 'tags', element: <TagsPage /> },
      { path: 'tags/:tag', element: <TagsPage /> },
      { path: 'about', element: <AboutPage /> },
      { path: 'contact', element: <ContactPage /> },
      { path: 'rss', element: <RssPage /> },
      { path: 'sitemap', element: <SitemapPage /> },
      { path: '404', element: <NotFoundPage /> },
      { path: '*', element: <NotFoundPage /> }
    ]
  },
  {
    path: '/studio',
    element: <AdminPage />,
  }
]);
